import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';

const App = lazy(() => import('./App'));
const AdminApp = lazy(() => import('./admin/AdminApp'));

const root = document.getElementById('root');
if (!root) {
  throw new Error('页面根节点不存在');
}

createRoot(root).render(
  <StrictMode>
    <Suspense fallback={<main className="auth-state-frame"><p>正在加载</p></main>}>
      {window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/')
        ? <AdminApp />
        : <App />}
    </Suspense>
  </StrictMode>,
);
